import React from 'react'
import { makeStyles } from '@mui/styles'
import { useDispatch, useSelector } from 'react-redux'
import PropTypes from 'prop-types'
import settingsConfig from '@/modules/settings/config'

import lang from '@/lang'

import { ButtonSquare } from '@/modules/base/components/buttons'

import { nextStep } from '@/redux/ducks/wizard/config'
import request from '@/modules/base/util/request'

const isMeinBuero = ENV.product === 'meinbuero'

const useStyles = makeStyles(theme => ({
  skip: (props) => ({
    cursor: 'pointer',
    fontSize: theme.fontSizes.default,
    color: theme.black,
    width: 'auto',
    height: 'auto',
    justifyContent: 'center',
    alignItems: 'center',
    display: props.skippable ? 'flex' : 'none',

    [theme.devices.mobile]: {
      width: '100%',
      padding: '20px 0',
    },
  }),
  footerWrapper: props => ({
    display: 'flex',
    alignItems: 'center',
    flexDirection: 'column',
    width: '100%',
    flexShrink: 0,
    zIndex: 20,
    '@media (min-width: 800px)': {
      padding: '0 40px 30px 40px',
      maxWidth: 'unset',
      gap: 20,
    },

    [theme.devices.mobile]: {
      padding: '0px 20px 20px 20px',
      ...(props.stickyBottomForMobile && {
        position: 'fixed',
        bottom: 0,
        height: '25vh',
        background: 'linear-gradient(180deg, rgba(255, 255, 255, 0) 0%, rgba(255, 255, 255, 0.6) 33.4%, #FFFFFF 100%)',
        justifyContent: 'flex-end',
      }),
    },
  }),

  footerWrapperMbo: {
    display: 'flex',
    alignItems: 'center',
    flexDirection: 'column',
    width: '100%',
    flexShrink: 0,
    zIndex: 20,
    '@media (min-width: 800px)': {
      padding: '0 40px 40px 40px',
      maxWidth: 'unset',
    },

    [theme.devices.mobile]: {
      padding: '0px 20px 20px 20px',
    },
  },
  next: {
    height: 54,
    '@media (min-width: 800px)': {
      width: 180,
    },
    '& .SVGInline': {
      display: 'none',
      '@media (min-width: 800px)': {
        display: 'inherit',
      },
    },
  },
}))

const Footer = ({
  onNextButtonClick,
  onSkipButtonClick,
  skippable,
  disabled,
  isMboOnboarding,
  stickyBottomForMobile = false,
}) => {
  const dispatch = useDispatch()
  const classes = useStyles({ skippable, stickyBottomForMobile })

  const { step, totalSteps } = useSelector(state => state.wizard.config)
  const onboardingStep = isMboOnboarding ? step < totalSteps - 1 : step < totalSteps
  const { ...onboardingData } = useSelector(state => state.onboarding.mainV2)
  const createData = (step) => {
    if (step === 0) {
      const { companyName, firstName, lastName, phone1 } = onboardingData.companyData
      const companyAddress = {
        companyName,
        firstName,
        lastName,
        phone1,
      }
      return { companyAddress }
    }
    if (step === 1) {
      const { isSubjectToImputedTaxation, isSmallBusiness, experience, industry } = onboardingData
      return { isSubjectToImputedTaxation, isSmallBusiness, experience, industry }
    }
  }

  const onSkipClick = () => {
    onSkipButtonClick && onSkipButtonClick()
    dispatch(nextStep())
  }

  const next = async() => {
    if (onNextButtonClick) {
      const checkStatus = await onNextButtonClick()

      if (checkStatus === true) {
        dispatch(nextStep())
        if (isMeinBuero && (step === 0 || step === 1)) {
          request(settingsConfig.account, { method: 'POST', auth: true, data: createData(step) })
        }
      }
    } else {
      dispatch(nextStep())
    }
  }

  const isOmoOnboardingStepPassword = !isMboOnboarding && step === 2

  let nextButtonLabel = lang.onboarding.general.next
  if (!onboardingStep || isOmoOnboardingStepPassword) {
    nextButtonLabel = isMeinBuero ? lang.onboardingV2.general.finish : lang.onboarding.general.finish
  }

  return (
    <>
      <div className={isMboOnboarding ? classes.footerWrapperMbo : classes.footerWrapper}>
        <ButtonSquare
          className={classes.next}
          disabled={disabled}
          label={nextButtonLabel}
          onClick={next}
        />
        <div className={classes.skip} onClick={onSkipClick}>Überspringen</div>
      </div>
    </>
  )
}

Footer.propTypes = {
  onNextButtonClick: PropTypes.func,
  onSkipButtonClick: PropTypes.func,
  skippable: PropTypes.bool,
  disabled: PropTypes.bool,
  stickyBottomForMobile: PropTypes.bool,
}

Footer.defaultProps = {
  skippable: false,
  disabled: false,
  stickyBottomForMobile: false,
}

export default Footer
